var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-more",class:_vm.classes,style:(_vm.cssProps)},[_vm._t("default"),_vm._v(" "),(_vm.buttonIconName)?_c('span',{staticClass:"button-more__icon",class:_vm.iconClasses},[_c('svg-icon',{attrs:{"name":_vm.buttonIconName}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }